
import React from 'react';

export default function TeamShortTermGoalDefaultMessage() 
{   
    return ( 
        <> 
            <div class="alert alert-light mt-2" role="alert">
                <small>
                    <p><b>No Team Short-Term Goals Created yet!</b></p>

                    <p>This view is designed to clearly communicate with your team what your common goal is and 
                       what Actions each team member is currently working on to achieve that goal by displaying 
                       a list of Assigned Actions below.
                    </p>

                    <div class="row mt-0">
                        <div class="col-1">
                            <a href="#"><img class="card-icon" src="./images/add.svg" alt="add" border="0"/></a>
                        </div>
                        <div class="col">
                            Click on the Add icon above to create a new Short-Term Goal.
                        </div>
                    </div>
          
                    <p class="mt-3">Let's get going!</p>
                </small>
            </div>
        </> 
    );
}